export default {
  complete: 'Credit + Business TR + Personal TR + Interim',
  credit: 'Credit',
  credit_business: 'Credit + Business TR',
  credit_business_est_debts: 'Credit + Business Est. Debt',
  credit_interim: 'Credit + Interim',
  credit_personal: 'Credit + Personal TR',
  credit_personal_interim: 'Credit + Personal TR + Interim',
  credit_business_personal: 'Credit + Business TR + Personal TR',
  credit_business_interim: 'Credit + Business TR + Interim'
}
